import React, {  useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";

export const Faults = props => {

  
  // Declare a new state variable, which we'll call "count"
  const [state, setState] = useStateIfMounted({

  });

  useEffect(() => {

  },[state]);

  return (
    <div>
        Faults Page
    </div>
  );
};
